import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const ShiroishiCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      })}
    >
      <Heading>{t("しろいし生活応援ポイントについて")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t(
          "しろいし生活応援ポイントに応募すると、3,000ポイントを発行いたします。",
        )}
        <br />
        <br />
        {t(
          "応募すると、ただちにポイントが付与され、令和8年12月31日までの期間、対象店舗で1ポイント＝1円として利用できます。",
        )}
      </p>
    </div>
  );
};
